/* ==========================================================================
   HOME PASSION - GORSEL NORMALLESTIRME

   IKI IS YAPAR:

     DOLDUR  (urun kartlari - karusel ve koleksiyon izgarasi)
       Fotografin ustunde altinda kalan BEYAZ BANDI kesip karti doldurur.
       Studyo cekimlerine DOKUNMAZ.

     SIGDIR  (koleksiyon dizini)
       Her gorselin icerigini kutunun %80'ine oturtur. Kirpma yok; amac
       butun karolarin ayni gorsel agirlikta olmasi.

   DOKUNULMAYAN YER: "Bu Kombini Tamamla" paneli (.hp-dc-img).
     O karolar kucuk oldugu icin en ufak kirpma bile goze batiyor.
     Orada CSS object-fit:contain kullaniliyor, gorselin tamami goruluyor.

   ----------------------------------------------------------------------
   NE ZAMAN KIRPILIR - UC DENEME, UCU DE OLCULDU

   1. DENEME: kenar bandinin parlakligi (studyo mu konsept mi?)
      BASARISIZ. 24 gorselin 19'u "studyo" cikti, cunku konsept cekimleri
      de beyaz tuvale gomulu; iki turun de kenari beyaz.

   2. DENEME: icerik kutusunun koseleri dolu mu? (dikdortgen fotograf mi?)
      BASARISIZ. Kare bir yastik da kutusunun koselerini doldurur.
      Olcum: BUTTERFLY studyo cekimi 4/4 kose dolu cikti ve yanlislikla
      konsept sayildi.

   3. DENEME - CALISAN: BANTLASMA.
      Beyaz bant her zaman TEK eksende olur. Fotograf yatay ise ustte ve
      altta bant kalir, dikeyse yanlarda. Yani icerik kutusunun iki kenari
      birbirinden belirgin sekilde farklidir.
      Studyo cekiminde urun tuvale ortalanmistir, iki kenar birbirine yakin.

      Olcumler:
        BUTTERFLY   (studyo)   g 0.84  y 0.85  -> fark 0.01  -> DOKUNMA
        IMPERIA     (studyo)   g 0.80  y 0.73  -> fark 0.08  -> DOKUNMA
        EVORA       (konsept)  g 1.00  y 1.00  -> fark 0.00  -> zaten dolu
        PALMPARADISE(konsept)  g 0.89  y 0.65  -> fark 0.24  -> KIRP

      Esik: fark >= 0.10 ise bant vardir, kirpilir.

   ----------------------------------------------------------------------
   IKI TUZAK, IKISI DE OLCULDU

   1) IntersectionObserver arka plan sekmesinde HIC tetiklenmiyor.
      Olcum: 10 gorselin 0'i islendi. IO kaldirildi, yerine kuyruk kondu.

   2) transform uzerinde CALISAN bir CSS gecisi inline stili eziyor.
      Olcum:  inline   = translate(4.17%, 0%) scale(1.667)
              computed = matrix(1, 0, 0, 1, 0, 0)
              getAnimations() -> CSSTransition transform, running, t=0,
                                 fill: backwards
      Calisan gecis hem CSS bildirimini hem inline stili yener; backwards
      da BASLANGIC degerini (none) tutar. Cozum: gecisi kisa sureligine
      iptal edip yaz.
   ========================================================================== */
(function(){
  'use strict';
  if(window.__hpImgFill) return;
  window.__hpImgFill = 1;

  var SIGDIR_ORAN = 0.80;   /* dizin karosunda icerik kutunun %80'ini kaplar */
  var BANT_ESIK   = 0.10;   /* iki kenar arasi bu kadar acilirsa bant vardir */

  var ONBELLEK = {};
  try{ ONBELLEK = JSON.parse(sessionStorage.getItem('hp_fill_v4') || '{}'); }catch(e){ ONBELLEK = {}; }
  var kayitZaman = null;
  function kaydet(){
    clearTimeout(kayitZaman);
    kayitZaman = setTimeout(function(){
      try{ sessionStorage.setItem('hp_fill_v4', JSON.stringify(ONBELLEK)); }catch(e){}
    }, 400);
  }

  function kucuk(u){ return String(u||'').replace(/(\.[a-z]+)(\?|$)/i, '_200x$1$2'); }

  function olc(url){
    return new Promise(function(res){
      var im = new Image();
      im.crossOrigin = 'anonymous';
      var bitti = false;
      var zaman = setTimeout(function(){ if(!bitti){ bitti = true; res(null); } }, 7000);

      im.onload = function(){
        if(bitti) return; bitti = true; clearTimeout(zaman);
        try{
          var N = 80;
          var c = document.createElement('canvas'); c.width = N; c.height = N;
          var x = c.getContext('2d', { willReadFrequently: true });
          x.clearRect(0, 0, N, N);
          x.drawImage(im, 0, 0, N, N);
          var d = x.getImageData(0, 0, N, N).data;

          function px(i, j){ var k=(j*N+i)*4; return { r:d[k], g:d[k+1], b:d[k+2], a:d[k+3] }; }
          function dolu(q){ return q.a > 20 && !(q.r > 238 && q.g > 238 && q.b > 238); }

          var ust=-1, alt=-1, sol=-1, sag=-1, v;
          for(var j2=0;j2<N;j2++){ v=false; for(var i2=0;i2<N;i2++){ if(dolu(px(i2,j2))){ v=true; break; } } if(v){ ust=j2; break; } }
          for(var j3=N-1;j3>=0;j3--){ v=false; for(var i3=0;i3<N;i3++){ if(dolu(px(i3,j3))){ v=true; break; } } if(v){ alt=j3; break; } }
          for(var i4=0;i4<N;i4++){ v=false; for(var j4=0;j4<N;j4++){ if(dolu(px(i4,j4))){ v=true; break; } } if(v){ sol=i4; break; } }
          for(var i5=N-1;i5>=0;i5--){ v=false; for(var j5=0;j5<N;j5++){ if(dolu(px(i5,j5))){ v=true; break; } } if(v){ sag=i5; break; } }

          if(ust<0 || sol<0){ res(null); return; }

          res({
            g: +((sag - sol + 1) / N).toFixed(3),
            y: +((alt - ust + 1) / N).toFixed(3),
            x: +(((sol + sag + 1) / 2) / N).toFixed(3),
            v: +(((ust + alt + 1) / 2) / N).toFixed(3)
          });
        }catch(err){ res(null); }
      };
      im.onerror = function(){ if(bitti) return; bitti = true; clearTimeout(zaman); res(null); };
      im.src = kucuk(url);
    });
  }

  function yaz(img, deger){
    var eski = img.style.transition;
    img.style.transition = 'none';
    img.style.transformOrigin = 'center center';
    img.style.transform = deger;
    void img.offsetWidth;

    var geri = false;
    function iade(){
      if(geri) return; geri = true;
      img.style.transition = eski || '';
      if(img.style.transform !== deger) img.style.transform = deger;
    }
    if(window.requestAnimationFrame) requestAnimationFrame(iade);
    setTimeout(iade, 80);
  }

  function uygula(img, m, kip){
    if(!m) return;
    var S;

    if(kip === 'sigdir'){
      var buyuk = Math.max(m.g, m.y);
      if(buyuk <= 0) return;
      S = SIGDIR_ORAN / buyuk;
      if(S < 0.65) S = 0.65;
      if(S > 2.20) S = 2.20;
      if(Math.abs(S - 1) < 0.03) return;
    } else {
      /* Sadece BANTLI gorseller kirpilir. Studyo cekiminde iki kenar
         birbirine yakindir, dokunulmaz. */
      if(Math.abs(m.g - m.y) < BANT_ESIK) return;
      var kucukKenar = Math.min(m.g, m.y);
      if(1 - kucukKenar < 0.03) return;
      S = 1 / kucukKenar;
      if(S > 2.20) S = 2.20;
    }

    var tx = -(m.x - 0.5) * S * 100;
    var ty = -(m.v - 0.5) * S * 100;

    yaz(img, 'translate(' + tx.toFixed(2) + '%,' + ty.toFixed(2) + '%) scale(' + S.toFixed(3) + ')');
    img.setAttribute('data-hp-fill', '1');
  }

  function kipBul(img){ return img.closest('.hp-cd-im') ? 'sigdir' : 'doldur'; }

  async function isle(img){
    var d = img.getAttribute('data-hp-fill');
    if(d === '1' || d === 'bekle') return;
    var url = img.currentSrc || img.getAttribute('src');
    if(!url) return;
    img.setAttribute('data-hp-fill', 'bekle');

    var anahtar = url.split('?')[0];
    var m = ONBELLEK[anahtar];
    if(m === undefined){
      m = await olc(url);
      ONBELLEK[anahtar] = m;
      kaydet();
    }
    img.removeAttribute('data-hp-fill');
    uygula(img, m, kipBul(img));
  }

  /* .hp-dc-img BILEREK YOK - "Bu Kombini Tamamla" karolari kirpilmaz. */
  var SEC = '.hp-pc-img img[data-main], .hp-vcat img, .hp-cd-im img';
  var queue=[], running=0, observed=new WeakSet();
  function enqueue(img){
    if(queue.indexOf(img)<0 && !img.getAttribute('data-hp-fill')) queue.push(img);
    drain();
  }
  function drain(){
    if(document.hidden) return;
    while(running<2 && queue.length){
      running++;
      isle(queue.shift()).catch(function(){}).finally(function(){running--;drain();});
    }
  }
  var observer=window.IntersectionObserver ? new IntersectionObserver(function(entries){
    entries.forEach(function(entry){if(entry.isIntersecting){observer.unobserve(entry.target);enqueue(entry.target);}});
  },{rootMargin:'300px'}) : null;
  function tara(kok){
    (kok || document).querySelectorAll(SEC).forEach(function(img){
      if(observed.has(img)) return;
      observed.add(img);
      if(observer) observer.observe(img); else enqueue(img);
    });
  }
  function baslat(){tara();}
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',baslat);
  else baslat();
  document.addEventListener('visibilitychange',function(){if(!document.hidden)drain();});
  document.addEventListener('shopify:section:load',function(e){tara(e.target);});
  window.hpImgFillScan = tara;
})();
